import { EntityType } from "@withorbit/core";
import { Dexie as DexieDB } from "dexie";
import { DexieDerivedTaskComponentKeys, DexieEntityKeys, DexieEventKeys, DexieMetadataKeys, DexieTable, } from "./tables.js";
export class DexieDatabase extends DexieDB {
    [DexieTable.Events];
    [DexieTable.Entities];
    [DexieTable.DerivedTaskComponents];
    [DexieTable.Metadata];
    constructor(name, indexedDB) {
        super(name, { indexedDB });
        this.version(2)
            .stores({
            [DexieTable.Events]: [
                `++${DexieEventKeys.SequenceNumber}`,
                `&${DexieEventKeys.ID}`,
                DexieEventKeys.EntityID,
                `[${DexieEventKeys.EntityID}+${DexieEventKeys.SequenceNumber}]`,
            ].join(", "),
            [DexieTable.Entities]: [
                `++${DexieEntityKeys.RowID}`,
                `&${DexieEntityKeys.ID}`,
                `[${DexieEntityKeys.EntityType}+${DexieEntityKeys.RowID}]`,
            ].join(", "),
            [DexieTable.DerivedTaskComponents]: [
                `&[${DexieDerivedTaskComponentKeys.TaskID}+${DexieDerivedTaskComponentKeys.ComponentID}]`,
                DexieDerivedTaskComponentKeys.TaskID,
                DexieDerivedTaskComponentKeys.DueTimestampMillis,
            ].join(", "),
            [DexieTable.Metadata]: `&${DexieMetadataKeys.Key}`,
        })
            .upgrade((tx) => {
            tx.table(DexieTable.Entities)
                .where(DexieEntityKeys.EntityType)
                .equals(EntityType.Task)
                .filter((row) => {
                return JSON.parse(row.data).isDeleted;
            })
                .toArray((deletedRows) => {
                tx.table(DexieTable.DerivedTaskComponents)
                    .where(DexieDerivedTaskComponentKeys.TaskID)
                    .anyOf(deletedRows.map(({ id }) => id))
                    .delete();
            });
        });
        this.events = this.table(DexieTable.Events);
        this.entities = this.table(DexieTable.Entities);
        this.derived_taskComponents = this.table(DexieTable.DerivedTaskComponents);
        this.metadata = this.table(DexieTable.Metadata);
    }
}
//# sourceMappingURL=dexie.js.map